package com.bikompanion.ui.install

/** How a rider on this device can get the app. */
sealed interface AppInstallOffer {
    /** iOS has no install API, so the rider has to be told where Safari keeps the option. */
    data object AddToHomeScreen : AppInstallOffer

    data class OpenStore(
        val url: String,
    ) : AppInstallOffer
}
